var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d0f12fcdf9a81ce2117926f1bde72d1ef5bff0ec"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["breeze@otovo"]={id:"d0f12fcdf9a81ce2117926f1bde72d1ef5bff0ec"};
      